/* SEUNIQUE — Home custom. Scoped to .su-page. Caricato via asset_url (mai inline). */
(function () {
  function init() {
    var root = document.querySelector('.su-page');
    if (!root) return;
    root.classList.add('js-ready');

    /* Reveal on scroll */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      root.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    }

    /* Hero slider */
    (function () {
      var slides = [].slice.call(root.querySelectorAll('.hslide'));
      var dotsWrap = root.querySelector('#slDots');
      if (slides.length < 2 || !dotsWrap) return;
      var i = 0, timer;
      slides.forEach(function (_, k) {
        var b = document.createElement('button');
        b.className = 'sl-dot' + (k === 0 ? ' active' : '');
        b.setAttribute('aria-label', 'Vai alla slide ' + (k + 1));
        b.onclick = function () { go(k); reset(); };
        dotsWrap.appendChild(b);
      });
      var dots = [].slice.call(dotsWrap.children);
      function go(n) {
        slides[i].classList.remove('active'); dots[i].classList.remove('active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('active'); dots[i].classList.add('active');
      }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }
      var nx = root.querySelector('#slNext'), pv = root.querySelector('#slPrev');
      if (nx) nx.onclick = function () { next(); reset(); };
      if (pv) pv.onclick = function () { prev(); reset(); };
      function start() { timer = setInterval(next, 5500); }
      function reset() { clearInterval(timer); start(); }
      var sl = root.querySelector('#slider');
      if (sl) {
        sl.addEventListener('mouseenter', function () { clearInterval(timer); });
        sl.addEventListener('mouseleave', start);
        var sx = 0;
        sl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        sl.addEventListener('touchend', function (e) {
          var d = sx - e.changedTouches[0].clientX;
          if (Math.abs(d) > 40) { d > 0 ? next() : prev(); reset(); }
        }, { passive: true });
      }
      start();
    })();

    /* UGC video slider (auto-scroll + arrows) */
    (function () {
      var track = root.querySelector('#ugcTrack');
      if (!track) return;
      var card = track.querySelector('.vid');
      if (!card) return;
      function step() { return card.offsetWidth + 16; }
      var nx = root.querySelector('#ugcNext'), pv = root.querySelector('#ugcPrev');
      if (nx) nx.onclick = function () { track.scrollBy({ left: step(), behavior: 'smooth' }); reset(); };
      if (pv) pv.onclick = function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); reset(); };
      var t;
      function auto() {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 6) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        }
      }
      function start() { t = setInterval(auto, 3200); }
      function reset() { clearInterval(t); start(); }
      track.addEventListener('mouseenter', function () { clearInterval(t); });
      track.addEventListener('mouseleave', start);
      start();
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();